<template>
  <AiEducationLayout :menu-items="menuItems">
    <EducationPageHeader title="错题本" description="整理学习过程中需要再次巩固的题目" />
    <ContentWrap>
      <EducationState
        state="empty"
        title="错题本接口尚未开放"
        description="当前后端还没有提供学生错题明细接口，因此不会展示虚构的题目或统计数据。接口接入后这里会自动显示错题和知识点。"
      />
    </ContentWrap>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import AiEducationLayout from '../layout/AiEducationLayout.vue'
import type { EducationMenuItem } from '../layout/types'
import EducationPageHeader from '../components/EducationPageHeader.vue'
import EducationState from '../components/EducationState.vue'

defineOptions({ name: 'AiEducationStudentWrongAnswers' })
const menuItems: EducationMenuItem[] = [
  {
    title: '学习首页',
    path: '/ai-Application-center/ai-education/student/home',
    icon: 'ep:home-filled'
  },
  {
    title: '我的课程',
    path: '/ai-Application-center/ai-education/student/courses',
    icon: 'ep:reading'
  },
  {
    title: '我的作业',
    path: '/ai-Application-center/ai-education/student/assignments',
    icon: 'ep:document-checked'
  },
  {
    title: '错题本',
    path: '/ai-Application-center/ai-education/student/wrong-answers',
    icon: 'ep:warning'
  },
  {
    title: '学习计划',
    path: '/ai-Application-center/ai-education/student/learning-plans',
    icon: 'ep:calendar'
  },
  {
    title: '学习报告',
    path: '/ai-Application-center/ai-education/student/learning-report',
    icon: 'ep:data-analysis'
  },
  {
    title: 'AI 学伴',
    path: '/ai-Application-center/ai-education/student/assistant',
    icon: 'ep:magic-stick'
  }
]
</script>
